// Central de Treinamento (épico PO1-3504) — endpoints do backend_hub, módulo
// `treinamento`. Usar `api` (API_URL), não `ApiHubBackend`.
//
//   GET   /treinamento/tutoriais?produto=<COD>        → Tutorial[] (só o que o usuário vê)
//   GET   /treinamento/tutoriais/:codigo/manual       → { url } (pré-assinada, 15 min)
//   GET   /treinamento/vistos                         → { vistos: [codigo] }
//   PUT   /treinamento/vistos/:codigo                 → { vistos }
//   GET   /treinamento/admin/tutoriais                → TutorialAdmin[] (inclui inativos; só admin)
//   POST  /treinamento/admin/tutoriais                → TutorialAdmin
//   PUT   /treinamento/admin/tutoriais/:id            → TutorialAdmin
//   PATCH /treinamento/admin/tutoriais/:id/status     → { status }
//   POST  /treinamento/admin/tutoriais/:id/manual     → multipart "arquivo" (PDF, 20 MB)
//
// Tutorial = { codigo, titulo, resumo, produtos[], youtubeId, duracaoSegundos,
//              capitulos[{s,titulo}], telas[{rota,aba?,s}], passos[], temManual,
//              dataPublicacao, novo }
// TutorialAdmin = Tutorial + { id, status, ordem, permissao, conteudoTexto,
//                              manualNomeArquivo, manualTamanhoBytes }
//
// O interceptor de services/api.js remove o Content-Type quando o body é FormData.
// Sem `?.`/`??`: o build roda em CRA 3.4 / Node 12.
import api from "./api";

export const MANUAL_MAX_BYTES = 20 * 1024 * 1024;
export const MANUAL_LEGENDA = "Somente PDF · até 20 MB";

export async function listarTutoriais(produto) {
  const { data } = await api.get("/treinamento/tutoriais", { params: produto ? { produto } : undefined });
  return Array.isArray(data) ? data : [];
}

// Bytes do PDF do manual, com login (PO1-3738). O visualizador do Hub desenha as
// páginas; o link do S3 não chega ao navegador.
export async function baixarManualPdf(codigo) {
  const { data } = await api.get(`/treinamento/tutoriais/${encodeURIComponent(codigo)}/manual/arquivo`, { responseType: "arraybuffer" });
  return new Uint8Array(data);
}

export async function listarVistos() {
  const { data } = await api.get("/treinamento/vistos");
  return (data && Array.isArray(data.vistos) && data.vistos) || [];
}

export async function marcarVisto(codigo) {
  const { data } = await api.put(`/treinamento/vistos/${encodeURIComponent(codigo)}`);
  return data;
}

// ─── Admin ───────────────────────────────────────────────────────────────────

export async function listarTutoriaisAdmin() {
  const { data } = await api.get("/treinamento/admin/tutoriais");
  return Array.isArray(data) ? data : [];
}

export async function criarTutorial(payload) {
  const { data } = await api.post("/treinamento/admin/tutoriais", payload);
  return data;
}

export async function atualizarTutorial(id, payload) {
  const { data } = await api.put(`/treinamento/admin/tutoriais/${id}`, payload);
  return data;
}

export async function alterarStatusTutorial(id, status) {
  const { data } = await api.patch(`/treinamento/admin/tutoriais/${id}/status`, { status: !!status });
  return data;
}

export function validarArquivoManual(arquivo) {
  if (!arquivo) return "Nenhum arquivo selecionado.";
  const nome = String(arquivo.name || "");
  if (!/\.pdf$/i.test(nome)) return "Só é aceito arquivo PDF.";
  if (!arquivo.size) return "Arquivo vazio.";
  if (arquivo.size > MANUAL_MAX_BYTES) return "Arquivo acima de 20 MB.";
  return null;
}

export async function enviarManual(id, arquivo) {
  const form = new FormData();
  form.append("arquivo", arquivo, arquivo.name);
  const { data } = await api.post(`/treinamento/admin/tutoriais/${id}/manual`, form);
  return data;
}

export function mensagemErroTreinamento(error, fallback) {
  const status = error && error.response && error.response.status;
  const payload = error && error.response && error.response.data;
  const doBackend =
    payload && typeof payload === "object"
      ? (typeof payload.error === "string" && payload.error) ||
        (typeof payload.message === "string" && payload.message) ||
        ""
      : typeof payload === "string"
        ? payload
        : "";
  if (status === 503) return "Storage de manuais não configurado no servidor. Avise o suporte.";
  if (status === 404) return "Tutorial não encontrado.";
  if (status === 403) return doBackend || "Você não tem acesso a esta ação.";
  if (status === 413) return "Arquivo acima do limite de 20 MB.";
  return doBackend || (error && error.message) || fallback || "Não foi possível concluir a operação.";
}
